<template>
  <a href="https://awase-no-awase.colour-field.jp" target="_blank" rel="noopener" class="banner-link"></a>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<style scoped>
.banner-link {
  display: block; /* aタグをブロック要素にしてサイズを持たせる */
  width: 100%;
  height: 50px; /* 必要に応じて高さを調整 */
  background-image: url('/awase-banner.png'); /* public内の画像を指定 */
  background-size: contain; /* 画像を枠いっぱいに表示 */
  background-position: center; /* 画像を中央に配置 */
  background-repeat: no-repeat; /* 画像を繰り返さない */
  background-color: #38C172;
  text-decoration: none; /* リンクの下線を消す */
  cursor: pointer; /* クリック可能なカーソル */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.banner-link:hover {
  transform: scale(1.02); /* ホバー時に少し拡大 */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}
</style>
